/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';

export interface VendorWorkspaceInviteLogControlllerSearchCursor$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 사용자 ID
 */
  userId?: string;

/**
 * 워크스페이스 ID
 */
  vendorWorkspaceId?: string;

/**
 * 대기 상태 필터
 */
  filterPending: boolean;
}

export function vendorWorkspaceInviteLogControlllerSearchCursor(http: HttpClient, rootUrl: string, params: VendorWorkspaceInviteLogControlllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceInviteLogControlllerSearchCursor.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('userId', params.userId, {});
    rb.query('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.query('filterPending', params.filterPending, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto>;
    })
  );
}

vendorWorkspaceInviteLogControlllerSearchCursor.PATH = '/api/vendorWorkspaceInviteLogs/invite/search/cursor';
